import { CAP, COMP_REPEATER, DIODE, RLC } from "../../../../constants/componentType";
import { getDefaultIndex, getDefaultName } from "../../../helper/setDefaultName";
import { RES, RLC_TYPES } from "../../../PCBHelper";
import { GENERIC } from "../../../PCBHelper/constants";
import { SchematicCanvas } from "../../../SchematicCanvas";
import preLayoutLibraryData from "../../library/PreLayoutData";
import { getDefaultPreRLCPreFixByType, getDefaultPreRLCValueByType, getDefaultSignalNames, getNewComponentName, getPointName, getSignalColor } from "./setupHelper";
import _ from "lodash";

class SchematicPlot {
  constructor(props) {
    const { elementsSvg, schematicSvg, width, height, top, elementsTypes, action = {}, GPIO, signalNumber, isSweep, isPuppeteer = false } = props;
    this.elementsSvg = elementsSvg;
    this.schematicSvg = schematicSvg;
    this.width = width;
    this.height = height;
    this.isPuppeteer = isPuppeteer;
    this.GPIO = GPIO || GENERIC;
    this.signalNumber = signalNumber || 1;
    this.elementsTypes = elementsTypes || [];
    this.updatePreLayoutInfo = action.updatePreLayoutInfo;
    this.compUpdate = action.compUpdate;
    /*   this.signalsUpdate = action.signalsUpdate; */
    this.signalPointsUpdate = action.signalPointsUpdate;
    this.openCompBox = action.openCompBox;
    this.closeCompBox = action.closeCompBox;
    this.selectSignalSection = action.selectSignalSection;
    this.showTemplateInfo = action.showTemplateInfo;
    this.closeTemplateInfo = action.closeTemplateInfo;
    this.getParam = action.getParam;
    this.action = action || {};
    this.top = top;
    this.isSweep = isSweep;
    this.initData();
  }

  initData = () => {
    this.canvas = new SchematicCanvas({
      elementsSvg: this.elementsSvg,
      schematicSvg: this.schematicSvg,
      width: this.width,
      height: this.height,
      top: this.top,
      rects: this.getRects(),
      lines: this.getLines(),
      elementsTypes: this.elementsTypes,
      container: this.getParam("canvasContainer", "state"),
      isSweep: this.isSweep,
      isPuppeteer: this.isPuppeteer,
      action: {
        rectUpdate: this.rectUpdate,
        rectDelete: this.rectDelete,
        openRectBox: this.openRectBox,
        createElement: this.createNewComponent,
        saveElement: this.saveComponent,
        createLine: this.createSignal,
        addNewLine: this.addNewTraceToSignal,
        deleteLine: this.deleteSignal,
        selectLine: this.selectSignalSection,
        addRectToLine: this.addCompToSignal,
        deleteLineSection: this.deleteSignalSection,
        showTemplateInfo: this.showTemplateInfo,
        closeTemplateInfo: this.closeTemplateInfo,
        templateData: preLayoutLibraryData,
        addSeriesRect: this.addSeriesComp,
        getParam: this.getParam,
        drawRectPorts: this.action.drawRectPorts
      }
    });
    !this.isSweep && this.canvas.drawElements();
    this.canvas.draw();
  }

  reDrawLines = () => {
    if (this.canvas && this.canvas.drawLines) {
      this.canvas.drawLines();
    }
  }

  createNewComponent = ({ key, x, y }) => {
    const comps = this.getParam("components") || [];
    const type = key === RLC ? RES : key;
    const layerComp = comps[0] && comps[0].layer ? comps[0].layer : null;
    let comp = {
      name: getNewComponentName(type, comps),
      type,
      pins: [],
      location: [x, y],
      width: [DIODE, RLC].includes(key) ? 2 : 3,
      height: key === DIODE ? 3 : 2,
      layer: layerComp || "Top"
    }
    if (key === RLC) {
      comp.voltage = "1.8";
      comp.value = "10K"
    }
    if (key === DIODE) {
      comp.voltage = "0";
      comp.model = {}
    }
    if (key === COMP_REPEATER) {
      comp.model = {}
    }
    return this.getRectByComp(comp);
  }

  saveComponent = (rectItem) => {
    const _comp = this.getCompByRect(rectItem);
    this.action.saveNewComponent(_comp);
  }

  getRects = () => {
    const comps = this.getParam("components") || [];
    return comps.map(comp => this.getRectByComp(comp));
  }

  getLines = () => {
    const signals = this.getParam("signals") || [];
    return signals.map(signal => this.getLineBySignal(signal));
  }

  getPoints = () => {
    const points = this.getParam("points") || [];
    return JSON.parse(JSON.stringify(points));
  }

  getLineBySignal = (signal) => {
    return {
      name: signal.name,
      color: signal.color,
      nets: [...(signal.nets || [])],
      sections: [...(signal.sections || []).map(secItem => {
        return {
          id: secItem.id,
          in: {
            ...secItem.in,
          },
          out: {
            ...secItem.out
          },
          model: { ...(secItem.template || {}) },
          length: secItem.traceLength
        }
      })],
      points: JSON.parse(JSON.stringify(signal.points || []))
    }
  }

  clear = () => {
    this.canvas.clear();
  }

  draw = () => {
    this.canvas.draw()
  }

  initContainer = ({ width, height, container }) => {
    this.canvas.initContainer({ width, height, container })
  }

  rectUpdate = (rectItem) => {
    const comp = this.getCompByRect(rectItem);
    this.compUpdate(comp, { isUpdate: true });
  }

  rectDelete = (rectItem) => {

    if (!rectItem.points.length) {
      this.closeCompBox(rectItem.name)
      this.compUpdate(rectItem, { isDelete: true });
      return;
    }
    const signals = this.getParam("signals") || [];
    const findSignal = signals.find(item => item.points && item.points.length);
    if (!findSignal) {
      this.closeCompBox(rectItem.name)
      this.compUpdate(rectItem, { isDelete: true });
      return;
    }

    const findSectionList = findSignal.sections.filter(item => (item.in && item.in.type === "component" && item.in.component === rectItem.name)
      || (item.out && item.out.type === "component" && item.out.component === rectItem.name));
    if (!findSectionList.length) {
      this.closeCompBox(rectItem.name)
      this.compUpdate(rectItem, { isDelete: true });
      return;
    }

    this.closeCompBox(rectItem.name)

    if (findSectionList.length === 1) {
      return this.deleteSignalSection(findSignal.name, findSectionList[0].id, rectItem.name);
    }

    const { components: _components, deleteRects: _deleteRects, newSignals, lines: _lines } = this.deleteSignalSection(findSignal.name, findSectionList[0].id, null, true);

    const findNewSignal = (newSignals || []).find(item => item.points && item.points.length) || {};
    const findSection = (findNewSignal.sections || []).find(item => (item.in && item.in.type === "component" && item.in.component === rectItem.name)
      || (item.out && item.out.type === "component" && item.out.component === rectItem.name)) || {};

    const { lines, components, deleteRects } = this.deleteSignalSection(findSignal.name, findSection.id, rectItem.name, false, { components: _components, signals: newSignals });
    const comps = [...(_components || []), ...(components || [])].map(item => item.name);

    return {
      deleteRects: [...new Set([...(_deleteRects || []), ...(deleteRects || [])])],
      lines: lines || _lines,
      updateRects: (components || []).filter(item => comps.includes(item.name)).map(item => this.getRectByComp(item))
    }
  }

  openRectBox = (rectItem, comps) => {
    const comp = this.getCompByRect(rectItem);
    this.openCompBox(comp, comps);
  }

  getCompByRect = (rectItem) => {
    const comp = {
      name: rectItem.name,
      location: [...(rectItem.location || [])],
      type: rectItem.type,
      width: rectItem.width,
      height: rectItem.height,
      pins: [...(rectItem.points || []).map(pin => {
        return {
          pin: pin.point,
          location: pin.location,
          net: pin.line,
          signal: pin.group
        }
      })],
      layer: rectItem.layer
    }
    if (comp && RLC_TYPES.includes(comp.type)) {
      comp.voltage = rectItem.voltage;
      comp.value = rectItem.value;
    }

    if (comp && comp.type === DIODE) {
      comp.voltage = rectItem.voltage;
      comp.model = { ...(rectItem.model || {}) };
    }

    if (comp && comp.type === COMP_REPEATER) {
      comp.model = { ...(rectItem.model || {}) };
    }

    return comp;
  }

  getRectByComp = (comp) => {
    return {
      name: comp.name,
      location: comp.location,
      type: comp.type,
      width: comp.width,
      height: comp.height,
      points: [...(comp.pins || []).map(pin => {
        return {
          point: pin.pin,
          location: pin.location,
          line: pin.net,
          group: pin.signal,
          model: { ...(pin.model || {}) }
        }
      })],
      layer: comp.layer,
      value: comp.value,
      voltage: comp.voltage,
      model: { ...(comp.model || {}) }
    }
  }

  updateCanvas = ({ comps, update, signals, isUpdateSignals = false, pins }) => {
    let rects = [];
    for (let comp of comps || []) {
      rects.push({ prevName: comp.prevName, ...this.getRectByComp(comp) });
    }
    if (rects.length && update.length) {
      this.canvas.updateRects(rects, update, false, isUpdateSignals && signals, pins);
    }
    if (isUpdateSignals && signals) {
      this.canvas.updateLines(signals.map(item => this.getLineBySignal(item)));
    }
  }

  closeExpand = (rectNames) => {
    if (rectNames.length) {
      this.canvas.closeExpandRects(rectNames);
    }
  }

  updateCanvasContainer = (container) => {
    if (!container || !container.width || !container.height) return;
    this.canvas.updateCanvasContainer(container);
  }

  createSignal = ({ currentLine }) => {

    const signalNames = getDefaultSignalNames(this.GPIO, this.signalNumber);
    let components = this.getParam("components") || [];
    const prevComponents = JSON.parse(JSON.stringify(components));
    let delPinsComps = []
    components = components.map(item => {
      if (item.pins.length) {
        delPinsComps.push(item.name)
        item.pins = [];
      }; return item;
    })
    //remove rlc diode component by auto added by signals
    components = components.filter(comp => ![...RLC_TYPES, DIODE].includes(comp.type)
      || (comp.location && comp.location.length))

    const startComp = currentLine.start.name,
      endComp = currentLine.end.name,
      resComps = components.filter(item => [...RLC_TYPES, DIODE].includes(item.type)).map(item => item.name);
    const startCompInfo = components.find(item => item.name === startComp) || {},
      endCompInfo = components.find(item => item.name === endComp) || {};

    const isStartRes = resComps.includes(startComp),
      isEndRes = resComps.includes(endComp);
    const startValue = startCompInfo.value, endValue = endCompInfo.value, startType = startCompInfo.type,
      startVoltage = startCompInfo.voltage, endVoltage = endCompInfo.voltage, endType = endCompInfo.type;
    const startPreFix = getDefaultPreRLCPreFixByType(startType), endPrefix = getDefaultPreRLCPreFixByType(endType);

    let first = true, signals = [], compPins = {};
    for (let signalName of signalNames) {
      let signal = {
        name: signalName,
        nets: [signalName],
        sections: [],
        points: [],
        color: getSignalColor(signals.map(signal => signal.color))
      }
      let sectionId = 1,
        currentSection = {},
        sections = [],
        currSignalPoints = [];
      for (let i = 0; i < currentLine.points.length; i++) {
        const point = currentLine.points[i];
        //first component point
        if (i === 0) {
          let comp = startComp;
          if (isStartRes && !first) {
            comp = getDefaultName({ nameList: resComps, defaultKey: startPreFix, key: "", firstIndex: 1 });
            components.push({
              name: comp,
              location: [],
              width: 2,
              height: 2,
              pins: [],
              type: startType,
              layer: startCompInfo.layer || "Top",
              value: startValue,
              voltage: startVoltage
            });
            resComps.push(comp);
          }
          currentSection.in = {
            component: comp,
            pin: signalName,
            type: "component"
          };
          const pin = { pin: signalName, net: signalName, signal: signalName, location: first ? [parseInt(point.x), parseInt(point.y)] : [] };
          if (!compPins[comp]) {
            compPins[comp] = [pin]
          } else {
            compPins[comp].push(pin)
          }
          currSignalPoints.push({
            name: comp,
            pin: signalName,
            type: "component"
          })
          continue;
        }
        const isComp = i === currentLine.points.length - 1;
        //last component point
        if (currentSection.in && !currentSection.out) {
          if (isComp) {
            let _endComp = endComp;
            if (isEndRes && !first) {
              _endComp = getDefaultName({ nameList: resComps, defaultKey: endPrefix, key: "", firstIndex: 1 });
              components.push({
                name: _endComp,
                location: [],
                width: 3,
                height: 2,
                pins: [],
                type: endType,
                layer: endCompInfo.layer || "Top",
                value: endValue,
                voltage: endVoltage
              });
              resComps.push(_endComp);
            }
            currentSection.out = {
              component: _endComp,
              pin: signalName,
              type: "component"
            }
            const pin = { pin: signalName, net: signalName, signal: signalName, location: first ? [parseInt(point.x), parseInt(point.y)] : [] };
            if (!compPins[_endComp]) {
              compPins[_endComp] = [pin]
            } else {
              compPins[_endComp].push(pin)
            }
            currSignalPoints.push({
              name: _endComp,
              pin: signalName,
              type: "component"
            })
            currentSection.id = sectionId.toString();
            currentSection.template = {};
            currentSection.traceLength = "";
            sections.push({
              ...JSON.parse(JSON.stringify(currentSection))
            })
            currentSection = {
              in: {
                ...currentSection.out
              }
            };
            sectionId += 1;
          } else {
            const signalPointName = getDefaultName({ nameList: currSignalPoints, defaultKey: signalName, key: "name", delimiter: "_" });
            currSignalPoints.push({
              name: signalPointName,
              location: [point.x, point.y],
              type: "point"
            })
          }
        }
      }
      signal.sections = sections;
      if (first) {
        const currLinePoints = [{ name: sections[0].id, points: currSignalPoints }];
        signal.points = currLinePoints;
        first = false;
      }
      signals.push(signal);
    }

    let newComps = [];

    for (let comp of components) {

      if (delPinsComps.includes(comp.name)) {
        comp.pins = [];
      }

      if (compPins[comp.name]) {
        comp.pins = [...comp.pins, ...compPins[comp.name]];
        newComps.push(comp.name)
      } else if (delPinsComps.includes(comp.name)) {
        newComps.push(comp.name)
      }
    }

    this.updateCompValue(components, prevComponents, newComps);
    this.updatePreLayoutInfo({ signals, components, keys: ["signals", "components"] });

    return { lines: signals.map(item => this.getLineBySignal(item)), newRects: components.filter(item => newComps.includes(item.name)).map(item => this.getRectByComp(item)) };
  }

  addNewTraceToSignal = ({ currentLine }) => {
    let signals = this.getParam("signals") || [];
    const components = this.getParam("components") || [];
    const prevComponents = JSON.parse(JSON.stringify(components));

    const startComp = currentLine.start.name,
      endComp = currentLine.end.name,
      resComps = components.filter(item => [...RLC_TYPES, DIODE].includes(item.type)).map(item => item.name);
    const startCompInfo = components.find(item => item.name === startComp) || {},
      endCompInfo = components.find(item => item.name === endComp) || {};


    const isStartRes = resComps.includes(startComp),
      isEndRes = resComps.includes(endComp);
    const startValue = startCompInfo.value, endValue = endCompInfo.value, startType = startCompInfo.type,
      startVoltage = startCompInfo.voltage, endVoltage = endCompInfo.voltage, endType = endCompInfo.type;
    const startPreFix = getDefaultPreRLCPreFixByType(startType), endPrefix = getDefaultPreRLCPreFixByType(endType);

    let first = true, compPins = {}
    const newSecId = getDefaultIndex(signals[0].sections.length, signals[0].sections.map(item => item.id));

    const _signalName = signals[0].name;
    const findNet = signals[0].nets.find(item => !!item.replace(_signalName, "").match(/[0-9]+/g));
    const { delimiter } = splitPreLayoutNet(findNet || signals[0].nets[0], _signalName);
    const _newNet = getDefaultName({ nameList: signals[0].nets, defaultKey: _signalName, key: "", delimiter, firstIndex: 1 });
    const { num: netNum, delimiter: newDelimiter } = splitPreLayoutNet(_newNet, _signalName);

    for (let signal of signals) {
      let currentSection = {},
        currSignalPoints = [];
      const signalName = signal.name;
      const newNet = `${signal.name}${newDelimiter}${netNum}`;
      for (let i = 0; i < currentLine.points.length; i++) {
        const point = currentLine.points[i];
        //first component point
        if (i === 0) {
          let comp = startComp;
          if (isStartRes && !first) {
            comp = getDefaultName({ nameList: resComps, defaultKey: startPreFix, key: "", firstIndex: 1 });
            components.push({
              name: comp,
              location: [],
              width: 2,
              height: 2,
              pins: [],
              type: startType,
              layer: startCompInfo.layer || "Top",
              value: startValue,
              voltage: startVoltage
            });
            resComps.push(comp);
          }
          currentSection.in = {
            component: comp,
            pin: newNet,
            type: "component"
          };
          const pin = { pin: newNet, net: newNet, signal: signalName, location: first ? [parseInt(point.x), parseInt(point.y)] : [] };
          if (!compPins[comp]) {
            compPins[comp] = [pin]
          } else {
            compPins[comp].push(pin)
          }
          currSignalPoints.push({
            name: comp,
            pin: newNet,
            type: "component"
          })
          continue;
        }
        const isComp = i === currentLine.points.length - 1;
        //last component point
        if (currentSection.in && !currentSection.out) {
          if (isComp) {
            let _endComp = endComp;
            if (isEndRes && !first) {
              _endComp = getDefaultName({ nameList: resComps, defaultKey: endPrefix, key: "", firstIndex: 1 });
              components.push({
                name: _endComp,
                location: [],
                width: 3,
                height: 2,
                pins: [],
                type: endType,
                layer: endCompInfo.layer || "Top",
                value: endValue,
                voltage: endVoltage
              });
              resComps.push(_endComp);
            }
            currentSection.out = {
              component: _endComp,
              pin: newNet,
              type: "component"
            }
            const pin = { pin: newNet, net: newNet, signal: signalName, location: first ? [parseInt(point.x), parseInt(point.y)] : [] };
            if (!compPins[_endComp]) {
              compPins[_endComp] = [pin]
            } else {
              compPins[_endComp].push(pin)
            }
            currSignalPoints.push({
              name: _endComp,
              pin: newNet,
              type: "component"
            })
            currentSection.id = newSecId.toString();
            currentSection.template = {};
            currentSection.traceLength = "";
            signal.sections.push({
              ...JSON.parse(JSON.stringify(currentSection))
            })
           /*  currentSection = {
              in: {
                ...currentSection.out
              }
            }; */
          } else {
            const signalPointName = getDefaultName({ nameList: currSignalPoints, defaultKey: signalName, key: "name", delimiter: "_" });
            currSignalPoints.push({
              name: signalPointName,
              location: [point.x, point.y],
              type: "point"
            })
          }
        }
      }
      if (first) {
        signal.points.push({ name: currentSection.id, points: currSignalPoints })
        first = false;
      }
      signal.nets.push(newNet)
    }
    let newComps = [];

    for (let comp of components) {
      if (compPins[comp.name]) {
        comp.pins = [...comp.pins, ...compPins[comp.name]];
        newComps.push(comp.name)
      }
    }

    this.updateCompValue(components, prevComponents, newComps);
    this.updatePreLayoutInfo({ signals, components, keys: ["signals", "components"] });

    return { lines: signals.map(item => this.getLineBySignal(item)), newRects: components.filter(item => newComps.includes(item.name)).map(item => this.getRectByComp(item)) };
  }

  addCompToSignal = ({ currentLine }) => {
    let signals = this.getParam("signals") || [];
    const components = this.getParam("components") || [];
    const prevComponents = JSON.parse(JSON.stringify(components));
    const index = signals.findIndex(signal => signal.name === currentLine.end.name);
    if (index < 0) {
      return {};
    }

    const secIndex = signals[index].sections.findIndex(item => item.id === currentLine.end.section.id);
    if (secIndex < 0) {
      return {};
    }

    const startComp = currentLine.start.name,
      resComps = components.filter(item => [...RLC_TYPES, DIODE].includes(item.type)).map(item => item.name);
    const isRes = resComps.includes(startComp);
    const sameGroupComps = currentLine.start.rectNames || [];

    const startCompInfo = components.find(item => item.name === startComp) || {};

    const startPreFix = getDefaultPreRLCPreFixByType(startCompInfo.type);

    const value = startCompInfo.value, voltage = startCompInfo.voltage, model = startCompInfo.model;

    let currNet = null;
    let findNetSec = signals[index].sections[secIndex];

    if (signals[index].sections[secIndex].in && signals[index].sections[secIndex].in.type === "point" && signals[index].sections[secIndex].out && signals[index].sections[secIndex].out.type === "point") {
      findNetSec = signals[index].sections.find(item =>
        (item.out.type === "point" && item.out.component === signals[index].sections[secIndex].out.component && item.in && item.in.type === "component")
        || (item.in.type === "point" && item.in.component === signals[index].sections[secIndex].in.component && item.out && item.out.type === "component")) || {}
    }
    currNet = findNetSec.in && findNetSec.in.type === "component" ? findNetSec.in.pin : null;
    if (!currNet) {
      currNet = findNetSec.out && findNetSec.out.type === "component" ? findNetSec.out.pin : signals[index].name;
    }

    const prevOut = JSON.parse(JSON.stringify(signals[index].sections[secIndex].out));

    let pointExistNames = [], currSignalResInfo = [], secPointNames = [];
    //get new points name
    for (let it of signals[index].sections) {
      if (it.in && it.in.type === "point") {
        pointExistNames.push(it.in.component)
        secPointNames.push(it.in.component)
      }
      if (it.out && it.out.type === "point") {
        pointExistNames.push(it.out.component)
        secPointNames.push(it.out.component)
      }

      const findPoint = signals[index].points.find(item => item.name === it.id);
      const pointList = findPoint && findPoint.points ? findPoint.points.filter(item => item.type === "point").map(item => item.name) : [];
      pointExistNames.push(...pointList);

      if (it.in && it.in.type === "component" && resComps.includes(it.in.component)) {
        currSignalResInfo.push({ sectionId: it.id, name: it.in.component, type: "in" })
      }
      if (it.out && it.out.type === "component" && resComps.includes(it.out.component)) {
        currSignalResInfo.push({ sectionId: it.id, name: it.out.component, type: "out" })
      }
    }

    let pointName = "";

    if (!pointExistNames.length) {
      /*   for (let signal of signals) {
          let name = ""
          for (let it of signal.sections) {
            if (it.in && it.in.type === "point") {
              name = it.in.component;
              signal.name === currentLine.end.name && pointExistNames.push(it.in.component)
              break;
            } else if (it.out && it.out.type === "point") {
              name = it.out.component;
              signal.name === currentLine.end.name && pointExistNames.push(it.out.component)
              break;
            }
          }
          name = name.replace(/[0-9]+/ig, "");
          name && pointExistKeys.push(name)
        } */
      /*  pointName = getPointName(pointExistKeys); */
      pointName = `A1`;
    } else {
      pointName = pointExistNames[0].replace(/[0-9]+/ig, "");
      pointName = getDefaultName({ nameList: pointExistNames, defaultKey: pointName, key: "", firstIndex: 1 })
    }

    const otherSignals = signals.filter(item => item.name !== signals[index].name).map(item => item.name);

    const poIndex = signals[index].points.findIndex(item => item.name === currentLine.end.section.id);
    const secPoints = JSON.parse(JSON.stringify(signals[index].points[poIndex].points));
    const poStartIndex = secPoints.findIndex(item => item.name === currentLine.end.sectionPoints.start.name);
    const poEndIndex = secPoints.findIndex(item => item.name === currentLine.end.sectionPoints.end.name);
    if (poStartIndex < 0 || poEndIndex < 0) {
      return {};
    }

    let isFilterStartPoint = false, isStartPoint = false, isFilterEndPoint = false, isEndPoint = false;
    if (_.isEqual(secPoints[poStartIndex].location, [currentLine.end.x, currentLine.end.y])
/*       _.isEqual(secPoints[poEndIndex].location, [currentLine.end.x, currentLine.end.y]) */) {
      isFilterStartPoint = true;
      if (pointExistNames.includes(secPoints[poStartIndex].name)) {
        isStartPoint = true;
        pointName = secPoints[poStartIndex].name;
      }
    }

    if (_.isEqual(secPoints[poEndIndex].location, [currentLine.end.x, currentLine.end.y])) {
      isFilterEndPoint = true;
      if (pointExistNames.includes(secPoints[poEndIndex].name)) {
        isEndPoint = true;
        pointName = secPoints[poEndIndex].name;
      }
    }

    const sectionIds = signals[index].sections.map(item => item.id);
    let newSecId1 = null;
    //split prev section to two section (current section and newSec1)
    if (!isStartPoint && !isEndPoint) {
      signals[index].sections[secIndex].out = {
        component: pointName,
        pin: pointName,
        type: "point"
      };

      newSecId1 = getDefaultIndex(signals[index].sections.length, sectionIds);
      signals[index].sections.splice(secIndex + 1, 0, {
        id: newSecId1,
        in: {
          component: pointName,
          pin: pointName,
          type: "point"
        },
        out: prevOut,
        template: {},
        traceLength: ""
      });
      sectionIds.push(newSecId1);
    } else {
      const findPointSection = signals[index].sections.find(item => (item.in && item.in.type === "point" && item.in.component === pointName)
        || (item.out && item.out.type === "point" && item.out.component === pointName));
      if (!findPointSection) {
        const newSecId3 = getDefaultIndex(signals[index].sections.length, sectionIds);
        sectionIds.push(newSecId3)
        const newSecId4 = getDefaultIndex(signals[index].sections.length, sectionIds);
        sectionIds.push(newSecId4)
        const startPoint = secPoints[0], endPoint = secPoints[secPoints.length - 1];
        signals[index].sections.splice(secIndex + 1, 0, {
          id: newSecId3,
          in: {
            component: startPoint.name,
            pin: startPoint.type === "point" ? startPoint.name : currNet,
            type: startPoint.type
          },
          out: {
            component: pointName,
            pin: pointName,
            type: "point"
          },
          template: {},
          length: ""
        }, {
          id: newSecId4,
          in: {
            component: pointName,
            pin: pointName,
            type: "point"
          },
          out: {
            component: endPoint.name,
            pin: endPoint.type === "point" ? endPoint.name : currNet,
            type: endPoint.type
          },
          template: {},
          length: ""
        });
        const poIndex = secPoints.findIndex(item => item.name === pointName);
        signals[index].points.push({
          name: newSecId3,
          points: [...secPoints.filter((item, index) => index <= poIndex)]
        },
          {
            name: newSecId4,
            points: [...secPoints.filter((item, index) => index >= poIndex)]
          });
        signals[index].points = signals[index].points.filter(item => item.name !== currentLine.end.section.id);
        signals[index].sections = signals[index].sections.filter(item => item.id !== currentLine.end.section.id);
      }
    }

    //add new section 
    const newSecId2 = getDefaultIndex(signals[index].sections.length, sectionIds);

    signals[index].sections.splice(secIndex + 2, 0, {
      id: newSecId2,
      in: {
        component: pointName,
        pin: pointName,
        type: "point"
      },
      out: {
        component: startComp,
        pin: currNet,
        type: "component"
      },
      template: {},
      length: ""
    });

    //update components
    const comp = startComp;
    const pin = { pin: currNet, net: currNet, signal: signals[index].name, location: [currentLine.start.x, currentLine.start.y] };
    const compIndex = components.findIndex(item => item.name === comp);
    components[compIndex].pins.push(pin);

    let signalResComps = {}, newComps = [startComp];
    for (let signalName of otherSignals) {
      let comp = startComp;

      const { num: netNum, delimiter } = splitPreLayoutNet(currNet, signals[index].name);
      const netName = netNum ? `${signalName}${delimiter}${netNum}` : signalName;
      if (isRes) {
        if (sameGroupComps.length) {
          const index = components.findIndex(it => sameGroupComps.includes(it.name) && it.pins.find(it => it.signal === signalName));
          components[index].pins.push({ pin: netName, net: netName, signal: signalName, location: [] });
          comp = components[index].name;
        } else {
          comp = getDefaultName({ nameList: resComps, defaultKey: startPreFix, key: "", firstIndex: 1 });
          const obj = {
            name: comp,
            location: [],
            width: 3,
            height: 2,
            pins: [{ pin: netName, net: netName, signal: signalName, location: [] }],
            type: startCompInfo.type,
            layer: startCompInfo.layer || "Top"
          }
          if (startCompInfo.type === DIODE) {
            obj.width = 2;
            obj.height = 3;
            obj.voltage = voltage;
            obj.model = model;
          } else {
            obj.voltage = voltage;
            obj.value = value;
          }
          components.push(obj);
        }
        resComps.push(comp);
        signalResComps[signalName] = comp;
      } else {
        const pin = { pin: netName, net: netName, signal: signalName, location: [] };
        const compIndex = components.findIndex(item => item.name === comp);
        components[compIndex].pins.push(pin)
      }
      newComps.push(comp)
    }
    //split prev section to two section points
    if (!isStartPoint && !isEndPoint) {
      signals[index].points.splice(poIndex, 1);
      const findSec1 = signals[index].sections[secIndex];
      const sec1Point = [`${findSec1.in.type}::${findSec1.in.component}`, `${findSec1.out.type}::${findSec1.out.component}`].sort();

      let points1 = [...secPoints.filter((item, index) => index < poStartIndex || (index === poStartIndex && !isFilterStartPoint)), {
        name: pointName,
        location: [currentLine.end.x, currentLine.end.y],
        type: "point"
      }],
        points2 = [{
          name: pointName,
          location: [currentLine.end.x, currentLine.end.y],
          type: "point"
        }, ...secPoints.filter((item, index) => index > poEndIndex || (index === poEndIndex && !isFilterEndPoint))];
      let pointId1 = signals[index].sections[secIndex].id, pointId2 = newSecId1;
      const pointList = [`${points1[0].type}::${points1[0].name}`, `${points1[points1.length - 1].type}::${points1[points1.length - 1].name}`].sort();
      if (!_.isEqual(sec1Point, pointList)) {
        pointId1 = newSecId1;
        pointId2 = signals[index].sections[secIndex].id;
      }
      signals[index].points.push({
        name: pointId1,
        points: points1
      }, {
        name: pointId2,
        points: points2
      })
    }

    //add new section points
    let newPoints = [];
    for (let point of currentLine.points) {
      if (point.type) {
        newPoints.push({
          name: comp,
          pin: currNet,
          type: "component"
        })
      } else if (point.endType) {
        newPoints.push({
          name: pointName,
          location: [point.x, point.y],
          type: "point"
        })
      } else {
        const signalPointName = getDefaultName({ nameList: newPoints, defaultKey: signals[index].name, key: "name", delimiter: "_" });
        newPoints.push({
          name: signalPointName,
          location: [point.x, point.y],
          type: "point"
        })
      }
    }
    signals[index].points.push({ name: newSecId2, points: newPoints });

    const { signals: newSignals } = this.updateSignalSectionsByCurrSignal({ updateSignal: signals[index], pointName, signals, isRes, startComp, signalResComps, currSignalResInfo, resComps });
    //update other signals
    this.updateCompValue(components, prevComponents, newComps);
    this.updatePreLayoutInfo({ signals: newSignals, components, keys: ["signals", "components"] });
    return { lines: newSignals.map(item => this.getLineBySignal(item)), newRects: components.filter(item => newComps.includes(item.name)).map(item => this.getRectByComp(item)) }
  }

  addSeriesComp = ({ currentLine, isStartSeries, isEndSeries }) => {
    let signals = this.getParam("signals") || [];
    let components = this.getParam("components") || [];
    const prevComponents = JSON.parse(JSON.stringify(components));
    const startComp = currentLine.start.name,
      endComp = currentLine.end.name,
      resComps = components.filter(item => [...RLC_TYPES, DIODE].includes(item.type)).map(item => item.name);

    const startCompIndex = components.findIndex(item => item.name === startComp),
      endCompIndex = components.findIndex(item => item.name === endComp);

    const signalComp = isStartSeries ? startComp : endComp;
    const isLineStartRLC = resComps.includes(startComp) && signalComp === startComp,
      isLineEndRLC = resComps.includes(endComp) && signalComp === endComp;

    const index = signals.findIndex(signal => signal.points && signal.points.length);
    if (index < 0) {
      return {};
    }

    const secInIndex = signals[index].sections.findIndex(item => item.in && item.in.type === "component" && item.in.component === signalComp);
    const secOutIndex = signals[index].sections.findIndex(item => item.out && item.out.type === "component" && item.out.component === signalComp);

    if (secInIndex < 0 && secOutIndex < 0) {
      return {};
    }

    //find signal comp section, find same group rlc comp
    const secIndex = secInIndex > -1 ? secInIndex : secOutIndex;
    let section = signals[index].sections[secIndex];
    const secId1 = section.id;
    let type = "in";
    if (secOutIndex > -1) {
      type = "out"
    }

    const newSecId = getDefaultIndex(signals[index].sections.length, signals[index].sections.map(item => item.id));
    const signalName = signals[index].name;
    //[Signal1, Signal11] -> signalName=Signal1, find Signal11
    //[Signal1, Signal1N1] -> signalName=Signal1, find Signal1N1
    const findNet = signals[index].nets.find(item => !!item.replace(signalName, "").match(/[0-9]+/g));
    const { delimiter } = splitPreLayoutNet(findNet || signals[index].nets[0], signalName);
    const _newNet = getDefaultName({ nameList: signals[index].nets, defaultKey: signalName, key: "", delimiter, firstIndex: 1 });
    const { num: netNum, delimiter: newDelimiter } = splitPreLayoutNet(_newNet, signalName);

    //find new rlc comp section, find same group comp
    let endSectionId = null, endSecType = null, startSectionId = null, startSecType = null;
    if (isLineStartRLC && resComps.includes(endComp)) {
      const findInS = signals[index].sections.find(item => item.in && item.in.type === "component" && item.in.component === endComp);
      const findOutS = signals[index].sections.find(item => item.out && item.out.type === "component" && item.out.component === endComp);
      if (findInS) {
        endSectionId = findInS.id;
        endSecType = "in"
      } else if (findOutS) {
        endSectionId = findOutS.id;
        endSecType = "out"
      }
    }

    if (isLineEndRLC && resComps.includes(startComp)) {
      const findInS = signals[index].sections.find(item => item.in && item.in.type === "component" && item.in.component === startComp);
      const findOutS = signals[index].sections.find(item => item.out && item.out.type === "component" && item.out.component === startComp);
      if (findInS) {
        startSectionId = findInS.id;
        startSecType = "in"
      } else if (findOutS) {
        startSectionId = findOutS.id;
        startSecType = "out"
      }
    }
    const startPrefix = getDefaultPreRLCPreFixByType(components[startCompIndex].type), endPrefix = getDefaultPreRLCPreFixByType(components[endCompIndex].type);
    let newComps = [];
    for (let signal of signals) {
      const newNet = `${signal.name}${newDelimiter}${netNum}`;
      signal.nets.push(newNet);

      let _startComp = null, _endComp = null,
        startIndex = -1, endIndex = -1,
        startLocation = [currentLine.start.x, currentLine.start.y],
        endLocation = [currentLine.end.x, currentLine.end.y];
      if (signal.name === signals[index].name) {
        _startComp = startComp;
        _endComp = endComp;
        startIndex = startCompIndex;
        endIndex = endCompIndex;
        signal.points.push({
          name: newSecId,
          points: [
            {
              pin: newNet,
              name: startComp,
              type: "component"
            },
            {
              pin: newNet,
              name: endComp,
              type: "component"
            }
          ]
        })
      } else {
        _startComp = startComp;
        startIndex = startCompIndex;
        const findSec = signal.sections.find(it => it.id === secId1) || {};
        if (isLineStartRLC) {
          _startComp = findSec[type].component;
          startIndex = components.findIndex(item => item.name === _startComp);
        } else if (startSectionId && startSecType) {
          const findSSec = signal.sections.find(it => it.id === startSectionId) || {};
          _startComp = findSSec[startSecType].component;
          startIndex = components.findIndex(item => item.name === _startComp);
        } else if (resComps.includes(startComp)) {
          _startComp = getDefaultName({ nameList: resComps, defaultKey: startPrefix, key: "", firstIndex: 1 });
          components.push({
            name: _startComp,
            location: [],
            width: 3,
            height: 2,
            pins: [{ pin: newNet, net: newNet, signal: signal.name, location: [] }],
            type: components[startCompIndex].type,
            layer: components[startCompIndex].layer || "Top",
            value: components[startCompIndex].value,
            voltage: components[startCompIndex].voltage
          });
          startIndex = -1;
          resComps.push(_startComp)
        }

        _endComp = endComp;
        endIndex = endCompIndex;
        if (isLineEndRLC) {
          _endComp = findSec[type].component;
          endIndex = components.findIndex(item => item.name === _endComp);
        } else if (endSectionId && endSecType) {
          const findSSec = signal.sections.find(it => it.id === endSectionId) || {};
          _endComp = findSSec[endSecType].component;
          endIndex = components.findIndex(item => item.name === _endComp);
        } else if (resComps.includes(endComp)) {
          _endComp = getDefaultName({ nameList: resComps, defaultKey: endPrefix, key: "", firstIndex: 1 });
          components.push({
            name: _endComp,
            location: [],
            width: 3,
            height: 2,
            pins: [{ pin: newNet, net: newNet, signal: signal.name, location: [] }],
            type: components[endCompIndex].type,
            layer: components[endCompIndex].layer || "Top",
            value: components[endCompIndex].value,
            voltage: components[endCompIndex].voltage
          });
          endIndex = -1;
          resComps.push(_endComp)
        }
      }

      signal.sections.push({
        id: newSecId,
        in: {
          component: _startComp,
          pin: newNet,
          type: "component"
        },
        out: {
          component: _endComp,
          pin: newNet,
          type: "component"
        },
        template: {},
        traceLength: ""
      });
      startIndex > -1 && components[startIndex].pins.push({
        pin: newNet,
        signal: signal.name,
        net: newNet,
        location: signal.name === signals[index].name ? startLocation : []
      });

      endIndex > -1 && components[endIndex].pins.push({
        pin: newNet,
        signal: signal.name,
        net: newNet,
        location: signal.name === signals[index].name ? endLocation : []
      });
      newComps.push(_startComp, _endComp);
    }
    this.updateCompValue(components, prevComponents, newComps);
    this.updatePreLayoutInfo({ signals, components, keys: ["signals", "components"] });
    return { lines: signals.map(item => this.getLineBySignal(item)), newRects: components.filter(item => newComps.includes(item.name)).map(item => this.getRectByComp(item)) }
  }

  updateCompValue = (components, prevComponents, newComps) => {
    for (let comp of components) {
      const findComp = prevComponents.find(it => it.name === comp.name);

      if (comp.type === COMP_REPEATER && comp.model && comp.model.pairs && comp.model.pairs.length) {
        const pins = comp.pins.map(item => item.pin);
        comp.model.pairs = comp.model.pairs.filter(item => pins.includes(item.pin));
      }
      if (!findComp || !findComp.pins || !comp.pins) {
        continue;
      }
      if (!RLC_TYPES.includes(comp.type) || findComp.pins.length === comp.pins.length) {
        continue;
      }
      let isUpdate = false, prevDefaultValue = null, newValue = null, isUpdateValue = false;
      if (comp.pins.length === 2 && findComp.pins.length === 1) {
        newValue = getDefaultPreRLCValueByType(comp.type, false, true);
        prevDefaultValue = getDefaultPreRLCValueByType(comp.type, true, true);
        isUpdateValue = true;
      } else if ((!findComp.pins.length && comp.pins.length === 1) || (comp.pins.length === 1 && findComp.pins.length === 2)) {
        newValue = getDefaultPreRLCValueByType(comp.type, true, true);
        prevDefaultValue = getDefaultPreRLCValueByType(comp.type, false, true);
        if (!comp.voltage && parseFloat(comp.voltage) !== 0) {
          comp.voltage = comp.type === RES ? "1.8" : "0";
          isUpdate = true;
        }
        isUpdateValue = true;
      }

      if (isUpdateValue && ((comp.type === CAP && _.isEqual(prevDefaultValue, comp.value || {})) || (comp.type !== CAP && prevDefaultValue === comp.value))) {
        comp.value = newValue;
        isUpdate = true;
      }

      isUpdate && newComps.push(comp.name);
    }
  }

  deleteSignalSection = (signalName, sectionId, delComp, notSave, info,/* isCallBack, callBackCompName */) => {
    let signals = this.getParam("signals") || [];
    let components = this.getParam("components") || [];
    if (info) {
      signals = info.signals || signals;
      components = info.components || components;
    }
    const prevComponents = JSON.parse(JSON.stringify(components));
    const index = signals.findIndex(signal => signal.name === signalName);
    if (index < 0) {
      return {};
    }

    const secIndex = signals[index].sections.findIndex(item => item.id === sectionId);
    if (secIndex < 0) {
      return {};
    }
    const resComps = components.filter(item => [...RLC_TYPES, DIODE].includes(item.type)).map(item => item.name);

    let currSignalResInfo = [];
    //get new points name
    for (let it of signals[index].sections) {
      if (it.in && it.in.type === "component" && resComps.includes(it.in.component)) {
        currSignalResInfo.push({ sectionId: it.id, name: it.in.component, type: "in" })
      }
      if (it.out && it.out.type === "component" && resComps.includes(it.out.component)) {
        currSignalResInfo.push({ sectionId: it.id, name: it.out.component, type: "out" })
      }
    }
    let updateRects = [], isRes = false;
    const currSection = signals[index].sections[secIndex];
    if ((currSection.in && currSection.in.type === "component")) {
      const _inIsRes = this.removePinsInComp({ components, component: currSection.in.component, pin: currSection.in.pin, updateRects });
      isRes = _inIsRes ? _inIsRes : isRes;
    }
    if ((currSection.out && currSection.out.type === "component")) {
      const outIsRes = this.removePinsInComp({ components, component: currSection.out.component, pin: currSection.out.pin, updateRects });
      isRes = outIsRes ? outIsRes : isRes;
    }

    let removePointName = "";

    if (currSection.in && currSection.in.type === "point") {
      removePointName = currSection.in.component;
    }
    if (currSection.out && currSection.out.type === "point") {
      removePointName = currSection.out.component;
    }

    signals[index].sections = signals[index].sections.filter(item => item.id !== sectionId);

    const findPointsExists = signals[index].sections.filter(item => (item.in && item.in.type === "point" && item.in.component === removePointName) || (item.out && item.out.type === "point" && item.out.component === removePointName));
    if (findPointsExists.length === 2) {

      let firstSection = findPointsExists[0], secondSection = findPointsExists[1];
      const firstPointIndex = signals[index].points.findIndex(item => item.name === firstSection.id);
      const secondPointIndex = signals[index].points.findIndex(item => item.name === secondSection.id);
      const fSectionIndex = signals[index].sections.findIndex(item => item.id === firstSection.id);
      const sSectionIndex = signals[index].sections.findIndex(item => item.id === secondSection.id);
      const fPointIndex = signals[index].points[firstPointIndex].points.findIndex(item => item.name === removePointName);
      const sPointIndex = signals[index].points[secondPointIndex].points.findIndex(item => item.name === removePointName);

      let fLineIndex = fPointIndex === 0 ? 1 : signals[index].points[firstPointIndex].points.length - 2,
        sLineIndex = sPointIndex === 0 ? 1 : signals[index].points[secondPointIndex].points.length - 2;

      let pointDir = "X", inPointDir = "X";
      const outLineLocation = signals[index].points[secondPointIndex].points[sLineIndex].type === "component" ? this.findCompPin(components, signals[index].points[secondPointIndex].points[sLineIndex].name, signals[index].points[secondPointIndex].points[sLineIndex].pin) : signals[index].points[secondPointIndex].points[sLineIndex].location;
      const inLineLocation = signals[index].points[firstPointIndex].points[fLineIndex].type === "component" ? this.findCompPin(components, signals[index].points[firstPointIndex].points[fLineIndex].name, signals[index].points[firstPointIndex].points[fLineIndex].pin) : signals[index].points[firstPointIndex].points[fLineIndex].location;
      if (outLineLocation && signals[index].points[secondPointIndex].points[sPointIndex].location[0] - outLineLocation[0] === 0) {
        pointDir = "Y";
      }
      if (inLineLocation && signals[index].points[firstPointIndex].points[fPointIndex].location[0] - inLineLocation[0] === 0) {
        inPointDir = "Y";
      }
      signals[index].points[secondPointIndex].points = signals[index].points[secondPointIndex].points.filter(item => item.name !== removePointName);

      if (inPointDir === pointDir) {
        signals[index].points[firstPointIndex].points = signals[index].points[firstPointIndex].points.filter(item => item.name !== removePointName);
      }
      if (fPointIndex === 0 && sPointIndex !== 0) {
        signals[index].points[secondPointIndex].points.push(...signals[index].points[firstPointIndex].points);
      } else if (fPointIndex === 0 && sPointIndex === 0) {
        signals[index].points[secondPointIndex].points.unshift(...signals[index].points[firstPointIndex].points.reverse());
      } else if (fPointIndex !== 0 && sPointIndex === 0) {
        signals[index].points[secondPointIndex].points.unshift(...signals[index].points[firstPointIndex].points);
      } else if (fPointIndex !== 0 && sPointIndex !== 0) {
        signals[index].points[secondPointIndex].points = signals[index].points[secondPointIndex].points.reverse();
        signals[index].points[secondPointIndex].points.unshift(...signals[index].points[firstPointIndex].points);
      }
      const copySection = firstSection.in.type === "point" && firstSection.in.component === removePointName ? firstSection.out : firstSection.in;
      if (signals[index].sections[sSectionIndex].in.type === "point" && signals[index].sections[sSectionIndex].in.component === removePointName) {
        signals[index].sections[sSectionIndex].in = {
          ...copySection
        }
      } else if (signals[index].sections[sSectionIndex].out.type === "point" && signals[index].sections[sSectionIndex].out.component === removePointName) {
        signals[index].sections[sSectionIndex].out = {
          ...copySection
        }
      }
      signals[index].sections.splice(fSectionIndex, 1);
      signals[index].points.splice(firstPointIndex, 1);
    }
    signals[index].sections = signals[index].sections.filter(item => item.id !== currSection.id);
    signals[index].points = signals[index].points.filter(item => item.name !== currSection.id);
    /*  this.signalsUpdate(signals[index], { isUpdate: true }); */
    let findPoint = signals[index].sections.find(item => item.in && item.in.type === "point");
    let pointName = "";
    if (!findPoint) {
      findPoint = signals[index].sections.find(item => item.out && item.out.type === "point");
      pointName = findPoint ? findPoint.out.component || "" : "";
    } else {
      pointName = findPoint.in.component || "";
    }
    let { signals: newSignals, delComps } = this.updateSignalSectionsByCurrSignal({ updateSignal: signals[index], pointName, signals, sectionId: currSection.id, isRes, currSignalResInfo, resComps, isDel: true, components, updateRects });
    if ((delComps && delComps.length > 0) || delComp) {
      components = components.filter(item => {
        if ([...(delComps || []), delComp].includes(item.name)) {
          if (!item.pins.length) {
            return false;
          }
          let existPins = [];
          for (let pin of item.pins) {
            const findSignal = newSignals.find(it => it.name === pin.signal);
            const findSection = findSignal.sections.find(it =>
              (it.in && it.in.type === "component" && it.in.component === item.name && it.in.pin === pin.pin)
              || (it.out && it.out.type === "component" && it.out.component === item.name && it.out.pin === pin.pin));
            if (findSection) {
              existPins.push(pin.pin)
            }
          }
          if (!existPins.length) {
            return false
          }
          return true;
        }
        return true;
      }
      )
    }
    newSignals = newSignals.filter(item => item.sections && item.sections.length);
    newSignals.forEach(item => {
      let nets = [];
      for (let sec of item.sections) {
        if (sec.in && sec.in.type === "component") {
          nets.push(sec.in.pin)
        }
        if (sec.out && sec.out.type === "component") {
          nets.push(sec.out.pin)
        }
      }
      item.nets = item.nets.filter(net => nets.includes(net));
    })
    let updateComps = updateRects.map(item => item.name);
    this.updateCompValue(components, prevComponents, updateComps);
    !notSave && this.updatePreLayoutInfo({ signals: newSignals, components, keys: ["signals", "components"] });
    return {
      lines: newSignals.map(item => this.getLineBySignal(item)),
      newSignals,
      updateRects: components.filter(item => updateComps.includes(item.name)).map(item => this.getRectByComp(item)),
      deleteRects: delComp ? [...(delComps || []), delComp] : delComps,
      components
    }

  }

  updateSignalSectionsByCurrSignal = ({ updateSignal, pointName, signals, startComp, isRes, components, updateRects, signalResComps, sectionId, currSignalResInfo, resComps, isDel }) => {
    /*    this.compUpdate(components[compIndex], { isUpdate: true });
       this.signalsUpdate(signals[index], { isUpdate: true }); */
    let allPointExistKeys = [pointName.replace(/[0-9]+/ig, "")]
    let delComps = []
    for (let signal of signals) {
      if (signal.name === updateSignal.name) {
        continue;
      }
      const findSection = sectionId && isRes ? signal.sections.find(item => item.id === sectionId) : null;

      if (findSection && findSection.in && findSection.in.type === "component" && resComps.includes(findSection.in.component)) {
        this.removePinsInComp({ components, component: findSection.in.component, pin: findSection.in.pin, updateRects });
        delComps.push(findSection.in.component);
      }
      if (findSection && findSection.out && findSection.out.type === "component" && resComps.includes(findSection.out.component)) {
        this.removePinsInComp({ components, component: findSection.out.component, pin: findSection.out.pin, updateRects });
        delComps.push(findSection.out.component);
      }

      const _findSection = sectionId ? signal.sections.find(item => item.id === sectionId) : null;

      if (isDel && _findSection && _findSection.in && _findSection.in.type === "component" && !(resComps || []).includes(_findSection.in.component)) {
        this.removePinsInComp({ components, component: _findSection.in.component, pin: _findSection.in.pin, updateRects });
      }
      if (isDel && _findSection && _findSection.out && _findSection.out.type === "component" && !(resComps || []).includes(_findSection.out.component)) {
        this.removePinsInComp({ components, component: _findSection.out.component, pin: _findSection.out.pin, updateRects });
      }

      let itemResMap = {};
      for (let item of signal.sections) {
        if (item.in && item.in.type === "component" && resComps.includes(item.in.component)) {
          const findR = currSignalResInfo.find(it => it.sectionId === item.id && it.type === "in");
          if (findR && findR.name) {
            itemResMap[findR.name] = item.in.component;
          }
        }

        if (item.out && item.out.type === "component" && resComps.includes(item.out.component)) {
          const findR = currSignalResInfo.find(it => it.sectionId === item.id && it.type === "out");
          if (findR && findR.name) {
            itemResMap[findR.name] = item.out.component;
          }
        }
      }

      signal.sections = JSON.parse(JSON.stringify(updateSignal.sections || []));

      let currPointName = getPointName(allPointExistKeys);
      allPointExistKeys.push(currPointName);
      for (let secItem of signal.sections) {
        if (secItem.in && secItem.in.type === "component") {
          const { num: netNum, delimiter } = splitPreLayoutNet(secItem.in.pin, updateSignal.name);
          secItem.in.pin = !netNum ? signal.name : `${signal.name}${delimiter}${netNum}`;
          if (isRes && startComp === secItem.in.component && signalResComps) {
            secItem.in.component = signalResComps[signal.name];
          } else if (!!itemResMap[secItem.in.component]) {
            secItem.in.component = itemResMap[secItem.in.component];
          }
        }
        if (secItem.out && secItem.out.type === "component") {
          const { num: netNum, delimiter } = splitPreLayoutNet(secItem.out.pin, updateSignal.name);
          secItem.out.pin = !netNum ? signal.name : `${signal.name}${delimiter}${netNum}`;
          if (isRes && startComp === secItem.out.component && signalResComps) {
            secItem.out.component = signalResComps[signal.name];
          } else if (!!itemResMap[secItem.out.component]) {
            secItem.out.component = itemResMap[secItem.out.component];
          }
        }

        if (secItem.in && secItem.in.type === "point") {
          const prevName = secItem.in.component.match(/[0-9]+/g);
          const num = prevName ? prevName[0] : "1"
          secItem.in.component = `${currPointName}${num}`;
          secItem.in.pin = `${currPointName}${num}`;

        }
        if (secItem.out && secItem.out.type === "point") {
          const prevName = secItem.out.component.match(/[0-9]+/g);
          const num = prevName ? prevName[0] : "1"
          secItem.out.component = `${currPointName}${num}`;
          secItem.out.pin = `${currPointName}${num}`;
        }
      }
    }
    return { signals, delComps };
  }

  findCompPin = (components, component, pin) => {
    let location = [];
    const findComp = components.find(it => it.name === component);
    if (findComp && findComp.pins) {
      const point = findComp.pins.find(item => item.pin === pin);
      location = point ? point.location : [];
    }
    return location;
  }

  deleteSignal = (signalName) => {
    let signals = this.getParam("signals") || [];
    let components = this.getParam("components") || [];
    let updateRects = []

    /*     for (let comp of components) {
          if (comp.pins.find(pin => pin.signal === signalName)) {
            comp.pins = comp.pins.filter(item => item.signal !== signalName);
            updateRects.push(this.getRectByComp(comp));
          }
        }
        signals = signals.filter(item => item.name !== signalName); */
    let delComps = [];

    for (let comp of components) {
      if ([...RLC_TYPES, DIODE].includes(comp.type) && comp.pins.find(item => item.signal !== signalName)) {
        delComps.push(comp.name)
        continue;
      }
      comp.pins = []
      updateRects.push(this.getRectByComp(comp));
    }
    components = components.filter(item => !delComps.includes(item.name));
    signals = [];
    this.updatePreLayoutInfo({ signals, components, keys: ["signals", "components"] });
    return { updateRects, deleteRects: delComps }
  }

  removePinsInComp = ({ components, component, pin, updateRects, isRes }) => {
    let compIndex = components.findIndex(comp => comp.name === component);
    if (compIndex > -1) {
      components[compIndex].pins = components[compIndex].pins.filter(pinItem => pinItem.pin !== pin);
      const index = updateRects.findIndex(it => it.name === components[compIndex].name);
      if (index > -1) {
        updateRects[index] = this.getRectByComp(components[compIndex]);
      } else {
        updateRects.push(this.getRectByComp(components[compIndex]));
      }
      if ([...RLC_TYPES, DIODE].includes(components[compIndex].type)) {
        isRes = true;
      }
    }
    return isRes
  }

  reDrawSignals = (signals) => {
    const lines = signals.map(item => this.getLineBySignal(item));
    this.canvas.lines = lines;
    this.canvas.drawLines(lines);
  }

  removeAllSignals = (signalName) => {
    this.canvas && this.canvas.deleteLine(signalName)
  }

  removeSignalSection = (signalName, sectionId) => {
    this.canvas && this.canvas.deleteLineSection(signalName, sectionId)
  }

  removeTemplateText = () => {
    this.canvas && this.canvas.removeTemplateText();
  }

  getGridSize = (type) => {
    return this.canvas ? this.canvas.getGridSize(type) : 0;
  }

  openExpandComps = ({ name, names }) => {
    this.canvas && this.canvas.openExpandComps({ name, names });
  }
}

/* 
TEST: console.log(splitPreLayoutNet("Signal111","Signal11"))
console.log(splitPreLayoutNet("Signal1_1","Signal1"))
console.log(splitPreLayoutNet("Signal1N1","Signal1"))
console.log(splitPreLayoutNet("Signal2","Signal2"))
console.log(splitPreLayoutNet("SCL1","SCL"))
console.log(splitPreLayoutNet("SCL","SCL")) 

{ name: 'Signal11', num: '1', delimiter: '', hasDelimiter: false }
{ name: 'Signal1', num: '1', delimiter: '_', hasDelimiter: true }
{ name: 'Signal1', num: '1', delimiter: 'N', hasDelimiter: true }
{ name: 'Signal2', num: '', delimiter: 'N', hasDelimiter: true }
{ name: 'SCL', num: '1', delimiter: '', hasDelimiter: false }
{ name: 'SCL', num: '', delimiter: '', hasDelimiter: false }
 */

function splitPreLayoutNet(net, signalName) {
  //["Signal1N1", "Signal1_1", "Signal11","SCL1","SCL_1"];

  //Signal1_1, SLC_1
  if (net.includes("_")) {
    const netArr = net.split("_");
    return {
      name: netArr[0] || signalName,
      num: netArr[1] || "",
      delimiter: "_"
    }
  }
  //Signal11 -> 1
  //SCL1 -> 1
  //Signal1N1 -> N1
  const netStr = net.replace(signalName, "");

  if (!netStr) {
    if (signalName.match(/[0-9]+/g)) {
      return {
        name: signalName,
        num: "",
        delimiter: "N",
      }
    } else {
      return {
        name: signalName,
        num: "",
        delimiter: "",
      }
    }
  }
  //N1 -> [N1, N, 1]
  //1 -> null
  const netArr = netStr.match(/^([a-zA-Z]+)([0-9]+)$/);
  if (netArr && netArr.length) {
    return {
      name: signalName,
      num: netArr[2] || "",
      delimiter: netArr[1] || ""
    }
  } else if (netStr.match(/^\d+$/)) {
    return {
      name: signalName,
      num: netStr || "",
      delimiter: ""
    }
  }
  return {
    name: signalName,
    num: "",
    delimiter: ""
  }
}

export {
  SchematicPlot,
  splitPreLayoutNet
}